import React from "react";
import "./ApprochSection.css";

const stepsLeft = [
  {
    no: "01",
    title: "INITIAL CONSULTATION & DISCOVERY:",
    text:
      "We begin by deeply understanding your business goals, challenges, and technical requirements.",
  },
  {
    no: "02",
    title: "PROPOSAL & SCOPE DEFINITION:",
    text:
      "Based on discovery, we present a detailed proposal outlining scope, timelines, and cost estimates.",
  },
  {
    no: "03",
    title: "LEGAL & COMMERCIAL AGREEMENTS:",
    text:
      "We establish formal agreements, including NDAs and SLAs, ensuring clear terms and mutual protection.",
  },
  {
    no: "04",
    title: "PROJECT PLANNING & KICK-OFF:",
    text:
      "A dedicated project team is assigned, and a comprehensive project plan is developed and shared.",
  },
  {
    no: "05",
    title: "DESIGN & PROTOTYPING:",
    text:
      "We create wireframes, mockups, and interactive prototypes for your review and feedback.",
  },
];

const stepsRight = [
  {
    no: "06",
    title: "DEVELOPMENT & ITERATION:",
    text:
      "Our agile teams build the solution in sprints, with regular updates and opportunities for feedback.",
  },
  {
    no: "07",
    title: "QUALITY ASSURANCE & TESTING:",
    text:
      "Rigorous testing (functional, performance, security) is conducted to ensure a high-quality, bug-free product.",
  },
  {
    no: "08",
    title: "DEPLOYMENT & LAUNCH:",
    text:
      "We manage the seamless deployment of your solution to the chosen environment.",
  },
  {
    no: "09",
    title: "TRAINING & HANDOVER:",
    text:
      "We provide comprehensive training for your team and all necessary documentation.",
  },
  {
    no: "10",
    title: "POST-LAUNCH SUPPORT & MAINTENANCE:",
    text:
      "We offer ongoing support, maintenance, and updates to ensure continued optimal performance.",
  },
];

const StepItem = ({ no, title, text }) => (
  <div className="approach-step d-flex">
    <div className="approach-step__no">{no}</div>
    <div className="approach-step__text">
      <h5>{title}</h5>
      <p>{text}</p>
    </div>
  </div>
);

const ApprochSection = () => {
  return (
    <section id="approch-section" className="rs-approach rs-section-yellow">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="approach-heading">
              <span className="approach-eyebrow">OUR</span>
              <h2 className="approach-title">APPROACH</h2>
              <p className="approach-sub">
                A Collaborative Journey to Digital Excellence.
                <br className="d-none d-md-block" />
                Our structured approach ensures successful project delivery and client satisfaction:
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4 g-lg-5">
          <div className="col-lg-6">
            {stepsLeft.map((s) => (
              <StepItem key={s.no} {...s} />
            ))}
          </div>
          <div className="col-lg-6">
            {stepsRight.map((s) => (
              <StepItem key={s.no} {...s} />
            ))}
          </div>
        </div>
      </div>

      {/* Big watermark background text */}
      <div className="approach-watermark" aria-hidden>
        APPROACH
      </div>
    </section>
  );
};

export default ApprochSection;
